/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ResetTripwireRequest
 */
export interface ResetTripwireRequest {
  /**
   *
   * @type {string}
   * @memberof ResetTripwireRequest
   */
  tripwireName: string;
}

/**
 * Check if a given object implements the ResetTripwireRequest interface.
 */
export function instanceOfResetTripwireRequest(
  value: object,
): value is ResetTripwireRequest {
  if (!("tripwireName" in value) || value["tripwireName"] === undefined)
    return false;
  return true;
}

export function ResetTripwireRequestFromJSON(json: any): ResetTripwireRequest {
  return ResetTripwireRequestFromJSONTyped(json, false);
}

export function ResetTripwireRequestFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ResetTripwireRequest {
  if (json == null) {
    return json;
  }
  return {
    tripwireName: json["tripwireName"],
  };
}

export function ResetTripwireRequestToJSON(json: any): ResetTripwireRequest {
  return ResetTripwireRequestToJSONTyped(json, false);
}

export function ResetTripwireRequestToJSONTyped(
  value?: ResetTripwireRequest | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    tripwireName: value["tripwireName"],
  };
}
